// extracted by mini-css-extract-plugin
export default {"backButton":"notFound_backButton__sOO-n","wrapper":"notFound_wrapper__9NoUH","content":"notFound_content__tcGY-"};